import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { useAuthStore } from '../../../store/authStore';
import { USER_TYPES } from '../../../constants';

const SidebarContainer = styled.aside`
  width: 250px;
  background-color: #2c3e50;
  min-height: calc(100vh - 72px);
  padding: 24px 0;
  flex-shrink: 0;
`;

const Nav = styled.nav`
  display: flex;
  flex-direction: column;
`;

const NavItem = styled(NavLink)`
  padding: 14px 24px;
  color: #ecf0f1;
  text-decoration: none;
  font-size: 15px;
  font-weight: 500;
  transition: all 0.3s ease;
  border-left: 4px solid transparent;
  display: flex;
  align-items: center;
  gap: 12px;

  &:hover {
    background-color: #34495e;
    border-left-color: #3498db;
  }

  &.active {
    background-color: #34495e;
    border-left-color: #3498db;
    color: #3498db;
  }
`;

const Icon = styled.span`
  font-size: 18px;
`;

const Divider = styled.div`
  height: 1px;
  background-color: #34495e;
  margin: 16px 0;
`;

const SectionTitle = styled.div`
  padding: 8px 24px;
  color: #95a5a6;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const Sidebar = () => {
  const userProfile = useAuthStore(state => state.userProfile);
  const isAdmin = userProfile?.type === USER_TYPES.ADMIN;
  const isTeacherOrAdmin = isAdmin || userProfile?.type === USER_TYPES.TEACHER;

  return (
    <SidebarContainer>
      <Nav>
        <SectionTitle>메뉴</SectionTitle>

        <NavItem to="/dashboard/info">
          <Icon>📊</Icon>
          <span>정보</span>
        </NavItem>

        {isTeacherOrAdmin && (
          <>
            <NavItem to="/dashboard/programs">
              <Icon>📋</Icon>
              <span>프로그램 관리</span>
            </NavItem>
            <NavItem to="/dashboard/classes">
              <Icon>🎓</Icon>
              <span>수업</span>
            </NavItem>
          </>
        )}

        {isAdmin && (
          <>
            <Divider />
            <SectionTitle>관리</SectionTitle>
            <NavItem to="/dashboard/users">
              <Icon>👥</Icon>
              <span>회원관리</span>
            </NavItem>
          </>
        )}
      </Nav>
    </SidebarContainer>
  );
};

export default Sidebar;
